import { makeIntl } from '@mit/intl';

import type { BlockType } from '../schema';

const { FormattedMessage, useIntl } = makeIntl<BlockType>();

export { FormattedMessage, useIntl };
